export enum Icons {
    AutoRenew = "AutoRenew",
    Book = "Book",
    Bookmark = "Bookmark",
    BookmarkOutline = "BookmarkOutline",
    BookView = "BookView",
    Brain = "Brain",
    Casi = "Casi",
    Campaign = "Campaign",
    ChangeIndicatorInfo = "ChangeIndicatorInfo",
    ChangeIndicatorText = "ChangeIndicatorText",
    ChatPanel = "ChatPanel",
    Checklist = "Checklist",
    Checkmark = "Checkmark",
    CheckmarkOvalFilled = "CheckmarkOvalFilled",
    CheckmarkOvalOutline = "CheckmarkOvalOutline",
    ChevronDown = "ChevronDown",
    ChevronFirst = "ChevronFirst",
    ChevronLast = "ChevronLast",
    ChevronLeft = "ChevronLeft",
    ChevronRight = "ChevronRight",
    ChevronUp = "ChevronUp",
    Clock = "Clock",
    Close = "Close",
    CloseExpansion = "CloseExpansion",
    CodeReference = "CodeReference",
    Collapse = "Collapse",
    Copy = "Copy",
    Copy2 = "Copy2",
    DefaultAvatar = "DefaultAvatar",
    Delta = "Delta",
    Document = "Document",
    Dot = "Dot",
    Download = "Download",
    DownloadComplete = "DownloadComplete",
    DownloadRemove = "DownloadRemove",
    DownloadSync = "DownloadSync",
    DragAndDrop = "DragAndDrop",
    Edit = "Edit",
    EditNotes = "EditNotes",
    EmptyNotes = "EmptyNotes",
    Enlarge = "Enlarge",
    Enterprise = "Enterprise",
    Expand = "Expand",
    Eye = "Eye",
    File = "File",
    Folder = "Folder",
    FolderLight = "FolderLight",
    Glyph = "Glyph",
    GridView = "GridView",
    Highlighter = "Highlighter",
    History = "History",
    Home = "Home",
    Image = "Image",
    ImageReplace = "ImageReplace",
    ImageUpload = "ImageUpload",
    Individual = "Individual",
    Information = "Information",
    Lightbulb = "Lightbulb",
    List = "List",
    Logo = "Logo",
    LogoBlue = "LogoBlue",
    LogoColor = "LogoColor",
    MediaPlay = "MediaPlay",
    MediaPlayCircle = "MediaPlayCircle",
    Menu = "Menu",
    Menu2 = "Menu2",
    Message = "Message",
    MetaPanel = "MetaPanel",
    MoreHorizontal = "MoreHorizontal",
    MoreVertical = "MoreVertical",
    Moved = "Moved",
    NewMaterial = "NewMaterial",
    Note = "Note",
    Notebook = "Notebook",
    NotebookReferencePanel = "NotebookReferencePanel",
    NoteColorable = "NoteColorable",
    OpenBook = "OpenBook",
    OpenShare = "OpenShare",
    Pen = "Pen",
    Pencil = "Pencil",
    PencilPlus = "PencilPlus",
    Pin = "Pin",
    Placeholder = "Placeholder",
    Plus = "Plus",
    Preferences = "Preferences",
    Print = "Print",
    PushPin = "PushPin",
    Question = "Question",
    ReferenceLink = "ReferenceLink",
    ReferencePanel = "ReferencePanel",
    Retry = "Retry",
    Resize = "Resize",
    Scroll = "Scroll",
    Search = "Search",
    SendArrow = "SendArrow",
    Settings = "Settings",
    Share = "Share",
    Sitnav = "Sitnav",
    Sparkle = "Sparkle",
    StarFilled = "StarFilled",
    StarOutline = "StarOutline",
    Stars = "Stars",
    Stop = "Stop",
    Stopwatch = "Stopwatch",
    Team = "Team",
    TextBlock = "TextBlock",
    TextAlignCenter = "TextAlignCenter",
    TextAlignLeft = "TextAlignLeft",
    TextAlignRight = "TextAlignRight",
    ThumbsDown = "ThumbsDown",
    ThumbsUp = "ThumbsUp",
    ThumbsDownFilled = "ThumbsDownFilled",
    ThumbsUpFilled = "ThumbsUpFilled",
    TiaAdd = "TiaAdd",
    TiaChange = "TiaChange",
    TiaDelete = "TiaDelete",
    ToggleCard = "ToggleCard",
    ToggleTable = "ToggleTable",
    Trashcan = "Trashcan",
    Trashcan2 = "Trashcan2",
    Vector = "Vector",
    Warning = "Warning",
    WarningTriangle = "WarningTriangle",
    WifiOffline = "WifiOffline",
    ZoomIn = "ZoomIn",
    ZoomOut = "ZoomOut",
}
